// extracted by mini-css-extract-plugin
export var animationContainer = "_mg-0";
export var footer = "_mg-1";
export var gray = "_mg-2";
export var lineItem = "_mg-3";
export var lineItemImage = "_mg-4";
export var lineItemInfo = "_mg-5";
export var lineItemText = "_mg-6";
export var lineItems = "_mg-7";
export var modalContent = "_mg-8";
export var options = "_mg-9";
export var orderName = "_mg-a";
export var refundAmount = "_mg-b";